<?xml version="1.0" encoding="utf-8"?>

<template>

    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="44" height="44" viewBox="0 0 44 44">
        <defs>
            <clipPath id="clip-Down">
                <rect width="44" height="44"/>
            </clipPath>
        </defs>
        <g id="Down" clip-path="url(#clip-Down)">
            <rect width="44" height="44" fill="transparent"/>
            <g id="down_button" transform="translate(14765 8420)">
                <g id="Ellipse_926"  transform="translate(-14765 -8420)" :class="'svg-selected-background-color' + ' ' + svgStrokeClass"  stroke-width="1">
                    <circle cx="22" cy="22" r="22" stroke="none"/>
                    <circle cx="22" cy="22" r="21.5" fill="none"/>
                </g>
                <path id="Path_1781" d="M305.062,263l10,10,10-10" transform="translate(-15058.063 -8664.387)"
                      fill="none"
                      color="primary" :class="arrowDownColor"
                      stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
        </g>
    </svg>

</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "ArrowDownMoreContent_svg",

    computed: {
        ...mapGetters({
            getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
            getIsHighContrast: 'ThemeStore/getIsHighContrast'
        }),



        svgStrokeClass() {
          if(this.getIsHighContrast) {
              return 'svg-stroke-color';
          }
          return 'svg-stroke-lighter-color';
        },

        arrowDownColor() {
            if(this.getIsHighContrast) {
                return 'svg-stroke-color';
            }
            else return 'svg-stroke-primary-color';
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/MoreContentIcon.vue